export const getConnectedFontSize = (size = 'sm') => {
  return size === 'lg' ? '24px' : '18px';
};

export const getDisconnectedFontSize = (size = 'sm') => {
  return size === 'lg' ? '18px' : '12px';
};
